import {
  GET_USER_PROFILE,
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  REGISTER_REQUEST,
  SET_AUTH,
  STATUSES,
  RESET_AUTH,
} from "actions/ActionTypes";

export const loginRequest = (data, token, redirectTo, redirectState) => ({
  type: LOGIN_REQUEST,
  data,
  token,
  redirectTo: redirectTo || "/",
  redirectState: redirectTo ? redirectState : null,
});

export const registerRequest = (data, token, redirectTo, redirectState) => ({
  type: REGISTER_REQUEST,
  data,
  token,
  redirectTo: redirectTo || "/",
  redirectState,
});

export const logout = (token, message = null, redirectTo) => ({
  type: LOGOUT_REQUEST,
  token,
  message,
  redirectTo: redirectTo || "/",
});

export const removeUserData = () => ({
  type: GET_USER_PROFILE,
  status: STATUSES.SUCCESSFUL,
  params: {},
});

export const resetAuth = () => ({
  type: RESET_AUTH,
  loggedIn: false,
});

export const addUserSession = () => ({
  type: SET_AUTH,
  loggedIn: true,
});

export const removeUserSession = () => ({
  type: SET_AUTH,
  loggedIn: false,
});
